<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="addGnbReportTemplateDialog">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.templateName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="templateName" type="text" v-model="templateName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="neTypeName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.paramType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="paramTypeName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterSpace')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="spaceName">
            </div>
          </div>
        </div>
        <div class='col-sm-5'>
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.counterList')}}：</div>
            <ejs-listview ref='systemCounterList' :dataSource="templateCounterList" :fields="templateFields"></ejs-listview>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  export default {
    name: 'ShowGnbReportTemplateDetail',
    components: {
    },
    data() {
      return {
        templateName: '',
        neTypeName: '',
        paramTypeName: '',
        spaceName: '',
        templateCounterList: [],
        templateFields: {
          text: 'text',
          value: 'value'
        }
      }
    },
    methods: {
    },
    mounted() {
    }
  }
</script>

<style scoped>
</style>
